import { Box, Grid, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
// technical ==>
import ConstructionIcon from '@mui/icons-material/Construction'
// administrative ==>
import DescriptionIcon from '@mui/icons-material/Description'
// legal ==>
import PolicyIcon from '@mui/icons-material/Policy'
// accounting ==>
import EuroSymbolIcon from '@mui/icons-material/EuroSymbol'
// building ==>
import ApartmentIcon from '@mui/icons-material/Apartment'
// RH ==>
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
// Contract ==>
import HandshakeIcon from '@mui/icons-material/Handshake'
// other ==> Aucun icone
import {
  AutocompleteArrayInput,
  Datagrid,
  DateField,
  FilterForm,
  List,
  Loading,
  NumberField,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
  useGetOne,
  useListContext,
  useNotify,
  useRecordContext,
  useRefresh,
  useTranslate,
} from 'react-admin'
import UpsertFileButton, {
  ArchiveButton,
  LinkRelation,
  PreviewButton,
  SignedRelation,
  UpdateShared,
  UpsertFileDialog,
} from '../../components/file_upload'
import TextFieldWithTooltip from '../../components/text_field_with_tooltip'
import { TranslateWrapperTextField } from '../../components/translatable_field_wrapper'
import FileWithContext from '../../models/file_with_context'
import moment from 'moment'
import Utils from '../../ext_coproprietaires/Content/utils'
const Filters = ({ choicesCategories, choicesTypes, ...props }) => {
  let categories = Utils.docsCopros.categories.filter((categorie) =>
    choicesCategories.includes(categorie.id)
  )
  let types = Utils.docsCopros.types.filter((type) =>
    choicesTypes.includes(type.id)
  )
  return [
    <TextInput label="Recherche" source="query" alwaysOn />,
    <AutocompleteArrayInput
      alwaysOn
      source="categories"
      optionText="name"
      optionValue="id"
      label="categories"
      choices={categories}
    />,
    <AutocompleteArrayInput
      alwaysOn
      source="types"
      optionText="name"
      optionValue="id"
      label="Types"
      choices={types}
    />,
    <SelectInput
      source="shared"
      label="Niveau de partage"
      choices={[
        { id: 'not', name: 'Interne' },
        { id: 'coowners', name: 'Partagé aux copropriétaires' },
        { id: 'providers', name: 'Partagé aux prestataires' },
        { id: 'cs_members', name: 'Partagé aux membres du CS' },
      ]}
      alwaysOn
      sx={{
        marginBottom: 0,
      }}
    />,
  ]
}
const ListActions = ({
  choicesCategories,
  choicesTypes,
  copro_id,
  ...props
}) => {
  const refresh = useRefresh()
  return (
    <TopToolbar
      sx={{
        width: '100%',
        '.MuiToolbar-regular': {
          width: '100%',
        },
      }}
    >
      <Grid container spacing={1}>
        <Grid item xs={9}>
          <FilterForm
            style={{
              rowGap: 10,
            }}
            filters={Filters({
              choicesCategories,
              choicesTypes,
              ...props,
            })}
          />
        </Grid>
        <Box style={{ display: 'flex', alignItems: 'center' }}>
          <UpsertFileButton
            resource="file_with_context"
            documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
            issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
            previewAttachedFiles={false}
            showPrestaSelection={true}
            copro_id={copro_id}
            upload_by_type={'users'}
            saveResult={(result) => {
              if (
                result.accepted_files.length > 0 &&
                result.rejected_files.length === 0
              ) {
                refresh()
              }
            }}
            show_shared_select={true}
          />
        </Box>
      </Grid>
    </TopToolbar>
  )
}
export const Documents = ({
  copro_id,
  choicesCategories,
  ficheImmeuble,
  choicesTypes,
  copro,
  ...props
}) => {
  const [editData, setEditData] = useState([])
  const notify = useNotify()
  const translate = useTranslate()
  const refresh = useRefresh()
  const [showEditDialog, setShowEditDialog] = useState(false)
  const { data, isLoading, error } = useGetOne('file_with_context', {
    id: 'choices',
  })

  if (isLoading) {
    return <Loading />
  }

  let tr = (context, key) => ({
    id: key,
    name: translate(`hs.file.${context}.${key}`),
  })
  let types = data.types.map((t) => tr('type', t))
  let categories = data.categories.map((t) => tr('category', t))
  return (
    <>
      <List
        empty={
          <Empty refresh={refresh} copro_id={copro.internal_id} {...props} />
        }
        resource={`copros/${copro_id}/docs`}
        exporter={false}
        hasCreate={false}
        hasEdit={true}
        actions={
          <ListActions
            choicesCategories={choicesCategories}
            choicesTypes={choicesTypes}
            {...props}
            copro_id={copro.internal_id}
          />
        }
      >
        <Datagrid
          bulkActionButtons={false}
          rowClick={(id, basePath, record) => {
            const catetgoryId = categories.find(
              (c) => translate(c.name) === record.category
            )
            const typeId = types.find((t) => translate(t.name) === record.type)
            record = {
              ...record,
              type: typeId?.id,
              category: catetgoryId?.id,
            }
            setEditData([record])
            setShowEditDialog(true)
          }}
        >
          <Category label="Catégorie" />
          <TranslateWrapperTextField source="type" prefix={'hs.file'}>
            <TextField />
          </TranslateWrapperTextField>
          <TextFieldWithTooltip
            maxLength={20}
            source="purpose"
            label="Libellé"
          />
          <DateField source="issue_date" />
          <TextField source="issued_by" />
          <DeadLine label="Deadline" />
          <NumberFieldCustom
            label="Amount Incl Vat"
            source="amount_incl_vat"
            locales="fr-FR"
            options={{ style: 'currency', currency: 'EUR' }}
          />
          <NumberFieldCustom
            label="Amount Excl Vat"
            source="amount_excl_vat"
            locales="fr-FR"
            options={{ style: 'currency', currency: 'EUR' }}
          />
          <ActionButtons source="actions" />
        </Datagrid>
      </List>
      {showEditDialog && editData.length > 0 && (
        <UpsertFileDialog
          {...props}
          handleUpsertClose={(e) => {
            setEditData([])
            setShowEditDialog(false)
          }}
          showPrestaSelection={true}
          // showCoproSelection={true}
          copro_id={copro.internal_id}
          showUpsertDialog={showEditDialog}
          upload_by_type={'users'}
          saveResult={(result) => {
            if (result.rejected_files.length > 0) {
              result.rejected_files.forEach((rejectedFile) => {
                notify(
                  translate(
                    rejectedFile.message,
                    ...rejectedFile.internalValues
                  ),
                  'error'
                )
              })
            } else if (result.accepted_files.length > 0) {
              setEditData([])
              refresh()
            }
          }}
          defaultValue={editData}
        />
      )}
    </>
  )
}
const Category = () => {
  const record = useRecordContext()
  switch (record?.category) {
    case 'building':
      return (
        <>
          <ApartmentIcon />
        </>
      )
    case 'technical':
      return (
        <>
          <ConstructionIcon />
        </>
      )
    case 'administrative':
      return (
        <>
          <DescriptionIcon />
        </>
      )
    case 'legal':
      return (
        <>
          <PolicyIcon />
        </>
      )
    case 'accounting':
      return (
        <>
          <EuroSymbolIcon />
        </>
      )
    case 'rh':
      return (
        <>
          <PeopleAltIcon />
        </>
      )
    case 'contract':
      return (
        <>
          <HandshakeIcon />
        </>
      )
    default:
      return (
        <>
          <TranslateWrapperTextField source="category" prefix={'hs.file'}>
            <TextField />
          </TranslateWrapperTextField>
        </>
      )
  }
}
const DeadLine = () => {
  // Si NOW() - deadline < 2 mois Affiche la date en rouge et en gras code couleur (#F5CED5)
  const record = useRecordContext()
  if (record?.deadline) {
    const diff = moment().diff(moment(record.deadline), 'months')
    // deadline < NOW()
    const flag = moment(record.deadline).isBefore(moment())
    return (
      <DateField
        source="deadline"
        style={
          diff < 2 || flag
            ? {
                color: 'red',
                fontWeight: 'bold',
              }
            : {}
        }
      />
    )
  }
  return <></>
}

const NumberFieldCustom = ({ source, locales, options }) => {
  const record = useRecordContext()
  let value = record?.[source]
  if (!value) {
    return <></>
  }
  value = parseFloat(value).toFixed(2)
  return <>{parseFloat(value).toLocaleString(locales, options)}</>
}

const ActionButtons = () => {
  return (
    <Box
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box mr={'10px'}>
        <PreviewButton source="preview_document" />
      </Box>
      <Box mr={'10px'}>
        <SignedRelation />
      </Box>
      <Box mr={'10px'}>
        <UpdateShared source="shared" />
      </Box>
      <Box>
        <ArchiveButton source="archive" />
      </Box>
    </Box>
  )
}

const Empty = ({ copro_id, refresh, ...props }) => {
  return (
    <Box
      m={1}
      width={'100%'}
      display={'flex'}
      alignItems={'center'}
      justifyContent={'center'}
      flexDirection={'column'}
      minHeight={'350px'}
    >
      <Typography variant="h4" paragraph>
        Aucun document disponible
      </Typography>
      <UpsertFileButton
        resource="file_with_context"
        documentType={FileWithContext.DOCUMENT_TYPE.COPRO}
        issuedBy={FileWithContext.ISSUED_BY.HELLO_APP}
        previewAttachedFiles={false}
        showPrestaSelection={true}
        copro_id={copro_id}
        upload_by_type={'users'}
        saveResult={(result) => {
          if (
            result.accepted_files.length > 0 &&
            result.rejected_files.length === 0
          ) {
            refresh()
          }
        }}
        show_shared_select={true}
      />
    </Box>
  )
}
